import React from 'react';
import Logo from '../../../components/common/Logo/Logo';
import styles from '../CheckoutPage.module.css';

interface CheckoutHeaderProps {
  title?: string;
  subtitle?: string;
}

const CheckoutHeader: React.FC<CheckoutHeaderProps> = ({
  title = 'Contratar Consultoria',
  subtitle = '',
}) => (
  <header className={styles.header}>
    <Logo className={styles.logoCentered} />
    {title ? <h1 className={styles.headerTitle}>{title}</h1> : null}
    {subtitle && <p className={styles.headerSubtitle}>{subtitle}</p>}
  </header>
);

export default CheckoutHeader;
